import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-heart",
  "use": "icon-si-glyph-heart-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-heart\" id=\"icon-si-glyph-heart\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>930</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M12.958,1.03 C11.045,1.03 9.447,2.378 9.047,4.178 C8.631,2.375 7.026,1.03 5.102,1.03 C2.865,1.03 1.052,2.854 1.052,5.102 C1.052,11.598 9.057,14.94 9.057,14.94 C9.057,14.94 16.969,11.682 16.969,5.061 C16.969,2.833 15.174,1.03 12.958,1.03 L12.958,1.03 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-heart.svg
// module id = A+Op
// module chunks = 62